import { render, staticRenderFns } from "./VisitTag.vue?vue&type=template&id=b2618a46&scoped=true&functional=true"
var script = {}
import style0 from "./VisitTag.vue?vue&type=style&index=0&id=b2618a46&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "b2618a46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2618a46')) {
      api.createRecord('b2618a46', component.options)
    } else {
      api.rerender('b2618a46', component.options)
    }
    module.hot.accept("./VisitTag.vue?vue&type=template&id=b2618a46&scoped=true&functional=true", function () {
      api.rerender('b2618a46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/visitRegistry/components/VisitTag.vue"
export default component.exports